import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function StartHereSection() {
  const { t } = useTranslation();

  const whyItems = Array.from({ length: 8 }, (_, i) => t(`why.item${i + 1}`));
  const steps = Array.from({ length: 7 }, (_, i) => t(`startHere.step${i + 1}`));

  return (
    <>
      <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24 lg:px-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              {t('why.title')}
            </h2>
            <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {whyItems.map((item, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3"
                >
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-check-line text-sm leading-none"></i>
                  </span>
                  <span className="text-sm font-medium text-foreground-800">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-background-200 bg-secondary-50 p-6 md:p-8">
            <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950">
              {t('startHere.title')}
            </h2>
            <p className="mt-3 text-base text-foreground-600">{t('startHere.subtitle')}</p>
            <ol className="mt-6 space-y-3">
              {steps.map((step, i) => (
                <li key={i} className="flex items-center gap-3">
                  <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-secondary-500 text-xs font-bold text-background-50">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="text-sm font-medium text-foreground-800">{step}</span>
                </li>
              ))}
            </ol>
            <Link
              to="/usfans-spreadsheet"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-secondary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600 whitespace-nowrap cursor-pointer"
            >
              {t('startHere.cta')}
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line text-base leading-none"></i>
              </span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}